import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var ChevronLeft = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor"
  };
  return React.createElement(StyledIconBase, tslib_1.__assign({
    iconAttrs: attrs,
    iconVerticalAlign: "-.125em",
    iconViewBox: "0 0 320 512"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    fill: "currentColor",
    d: "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z",
    key: "k0"
  }));
});
ChevronLeft.displayName = 'ChevronLeft';
export var ChevronLeftDimensions = {
  height: undefined,
  width: undefined
};